/* eslint-disable import/prefer-default-export */
/* eslint-disable consistent-return */
/* eslint-disable prefer-spread */
// const needle = require("needle");

import { getSupaClient } from "../lib/supabase";

// Post to our backend Lambda functions
const fetchTweets = async (params) => {
  params.session = JSON.stringify(getSupaClient().auth.session());
  const initObj = {
    method: "get",
    headers: new Headers({ "Content-Type": "application/json" }),
  };
  const url = new URL(`${process.env.REACT_APP_API}/gettweets`);
  url.search = new URLSearchParams(params);
  return fetch(url, initObj)
    .then((response) => response.json())
    .then((responseJSON) => {
      const userArray = responseJSON.includes;
      const tweetArray = responseJSON.data;
      const newTweetArray = tweetArray.map((tweet) => {
        let user = null;
        user = userArray.find((element) => element.id === tweet.author_id);
        return {
          tweet,
          user,
        };
      });
      return newTweetArray;
    })
    .catch(function (err) {
      console.log("error in lambdaPost", err);
      return { error: err };
    });
};

export default fetchTweets;
// fetchTweets();
